import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { StoreProvider } from "./context/StoreContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PublicLayout from "./components/public/PublicLayout";
import Home from "./pages/public/Home";
import Catalog from "./pages/public/Catalog";
import ProductPage from "./pages/public/ProductPage";
import About from "./pages/public/About";
import Privacy from "./pages/public/Privacy";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/Products";
import Banners from "./pages/admin/Banners";
import Promotions from "./pages/admin/Promotions";
import Customers from "./pages/admin/Customers";
import Settings from "./pages/admin/Settings";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground" data-testid="admin-auth-loading">Verificando acesso…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/admin" element={<AuthProvider><Outlet /></AuthProvider>}>
          <Route path="login" element={<AdminLogin />} />
          <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<Dashboard />} />
            <Route path="produtos" element={<Products />} />
            <Route path="banners" element={<Banners />} />
            <Route path="promocoes" element={<Promotions />} />
            <Route path="clientes" element={<Customers />} />
            <Route path="configuracoes" element={<Settings />} />
          </Route>
        </Route>
        <Route element={<StoreProvider><PublicLayout /></StoreProvider>}>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/perfume/:slug" element={<ProductPage />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
